<template>
  <div class="product-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${productId ? 'Editar' : 'Cadastrar'} Produto`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'products.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <product-form
        @submit="onSubmit"
        :id="productId"
        :errors="errors"
        :saving="isSaving"
      ></product-form>
    </app-card>
  </div>
</template>

<script>
import ProductForm from '@/components/Forms/ProductForm.vue';
import ProductService from '@/services/product.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'product-form-page',
  mixins: [ToastMixin],
  components: {
    ProductForm,
  },
  data: () => {
    return {
      productId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.productId && this.save(data);
      this.productId && this.update(this.productId, data);
    },
    save(data) {
      this.isSaving = true;
      ProductService.save(data)
        .then(() => {
          this.toastify('Produto cadastrado com sucesso!');
          this.$router.push({ name: 'products.index' });
        })
        .catch(({ response }) => {
          if (response.status === 422) this.errors = response.data.errors;
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      ProductService.update(id, data)
        .then(() => {
          this.toastify('Produto atualizado com sucesso!');
          this.$router.push({ name: 'products.index' });
        })
        .catch(({ response }) => {
          if (response.status === 422) this.errors = response.data.errors;
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.productId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
